import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import AllContextProviders from "./contexts/AllContextProviders";
import { BrowserRouter } from "react-router-dom";
// import vConsole from "./vConsole";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
});
 
const baseName = import.meta.env.VITE_BASE_NAME;

ReactDOM.createRoot(document.getElementById("root")).render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter basename={baseName}>
      <AllContextProviders>
        <App />
      </AllContextProviders>
    </BrowserRouter>
    <ReactQueryDevtools />
  </QueryClientProvider>
);

/*
const enableVconsole = true;

const Root = enableVconsole ? vConsole.component( // 若 enableVconsole 為 true，載入 vConsole
  AllContextProviders(App)
) : (
  <AllContextProviders>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AllContextProviders>
);

const queryClient = new QueryClient();

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <React.StrictMode>
      {Root}
      <ReactQueryDevtools />
    </React.StrictMode>
  </QueryClientProvider>,
  document.getElementById("root")
);
以上程式碼將 enableVconsole 設為 true 時，載入 vConsole.component() 元件；設為 false 時，載入原本的 <App> 元件。 
 */